// extracted by mini-css-extract-plugin
module.exports = {"upgradeModal":"UpgradeModal_upgradeModal__vasfa","unclickable":"UpgradeModal_unclickable__uyl44"};